<svg width="26" height="40" viewBox="0 0 26 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M13 27.5c3.916 0 7.09-3.358 7.09-7.5V7.5C20.09 3.358 16.917 0 13 0S5.91 3.358 5.91 7.5V20c0 4.142 3.174 7.5 7.09 7.5zM24.818 15h-1.182c-.653 0-1.181.56-1.181 1.25V20c0 5.844-4.764 10.533-10.4 9.952-4.912-.507-8.51-5.178-8.51-10.397V16.25c0-.69-.528-1.25-1.181-1.25H1.182C.529 15 0 15.56 0 16.25v3.137c0 7.004 4.725 13.247 11.227 14.195v2.668H7.091c-.653 0-1.182.56-1.182 1.25v1.25c0 .69.529 1.25 1.182 1.25h11.818c.653 0 1.182-.56 1.182-1.25V37.5c0-.69-.529-1.25-1.182-1.25h-4.136v-2.638C21.103 32.693 26 26.945 26 20v-3.75c0-.69-.529-1.25-1.182-1.25z" id="9fgmx0a2xa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="t1eg6uaw8b" fill="#fff">
            <use xlink:href="#9fgmx0a2xa"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#9fgmx0a2xa"/>
        <g mask="url(#t1eg6uaw8b)" fill="currentColor">
            <path d="M0 0h26v40H0z"/>
        </g>
    </g>
</svg>
